import _ from 'lodash';

export default function focusNextElement(inputOnly, forwardSteps,controlId) {

const defaultFocusElements = 'a:not([disabled]), button:not([disabled]),input[type=text];not([disabled]), [tabindex]:not([disabled]):not([tabindex="-1"])';
const onlyFocusInputs = 'input:not([disabled]),button:not([disabled]), textarea:not([disabled])';

let focussableElements = defaultFocusElements

if(inputOnly) {
    focussableElements = onlyFocusInputs;
}

function getLastIndexByIdSubstring(focussable, substring) {
    // Use lodash's findLastIndex for cleaner logic
    return _.findLastIndex(focussable, el => el.id && el.id.includes(substring));
}

if (document.activeElement) {
    setTimeout(() => {
         const focussable = Array.prototype.filter.call(document.querySelectorAll(focussableElements), (element) => element.offsetWidth > 0 || element.offsetHeight > 0 || element === document.activeElement);
       
         if(!_.isUndefined(focussable)) {
            let index = focussable?.indexOf(document.activeElement);
    
            if (controlId) {
                    index = getLastIndexByIdSubstring(focussable, controlId);
                } else {
                    index = focussable?.indexOf(document.activeElement);
                }

            if(!_.isUndefined(index)) {
                if(forwardSteps) {
                    focussable[index + forwardSteps]?.focus();
                } else {
                focussable[index + 0]?.focus();
                }
            }
        }
}, 600)
}
}